import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoVerbaliVerificaScartoStep2Component } from './conservazione-carica-documento-verbali-verifica-scarto-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-verbali-verifica-scarto-step2', {
            url: '/conservazione-carica-documento-verbali-verifica-scarto',
            ncyBreadcrumb: {
                label: 'Carica Verbali di Verifica e di Scarto',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-verbali-verifica-scarto-step2 flex="100"></conservazione-carica-documento-verbali-verifica-scarto-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoVerbaliVerificaScartoStep2Module: string = ng
    .module('conservazione-carica-documento-verbali-verifica-scarto-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoVerbaliVerificaScartoStep2', ConservazioneCaricaDocumentoVerbaliVerificaScartoStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-verbali-verifica-scarto-step2/conservazione-carica-documento-verbali-verifica-scarto-step2.module.ts